import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { blogPosts } from "./BlogsData";
import '../../styles/Header.css';
import { Helmet } from "react-helmet";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const BLOGS_PER_PAGE = 10;

export default function Blogs() {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(blogPosts.length / BLOGS_PER_PAGE);
  const start = (currentPage - 1) * BLOGS_PER_PAGE;
  const currentBlogs = blogPosts.slice(start, start + BLOGS_PER_PAGE);

  useEffect(() => {
    document.body.classList.add('blogs-active');
    return () => {
      document.body.classList.remove('blogs-active');
    };
  }, []);  

  return (
    <div className="blogs-container">
      <Helmet>
              <title>Real Estate Blogs by JSB Homemakers:  Tips & Guides</title>
              <meta
                name="description"
                content="Explore expert real estate blogs by JSB Homemakers featuring, home-buying guides and real estate tips to help you make smarter real estate decisions in India"
              />
            </Helmet>
      <h1 className="blogs-page-title">Blogs List</h1>
      <div className="blogs-table-container">
        <table className="blogs-table">
          <thead>
            <tr>
              <th>Title</th>
            </tr>
          </thead>
          <tbody className='blogs-table-body'>
            {currentBlogs.map((post) => (
              <tr key={post.id}>
                <td>
                  <Link to={`/blogs/${post.id}`} className="blog-link">
                    {post.title}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
          className="pagination-button"
        >
          <ArrowBackIcon />
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
          className="pagination-button"
        >
          <ArrowForwardIcon />
        </button>
      </div>
    </div>
  );
}
